export const convertToCSV = (arr: any) => {
  let csvArr = []; //main CSV arr
  let csvKeyarr = []; //csv key arr
  for (let key in arr[0]) {
    csvKeyarr.push(key); // for header
  }
  let modifiedKeys = csvKeyarr.map(function (str) {
    let underscoreRemoved = str.replace(/_/g, ' ');
    let words = underscoreRemoved.split(' ');
    let capitalized = words.map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return capitalized.join(' ');
  });
  csvArr.push(modifiedKeys); //csv key arr

  for (let i = 0; i <= arr.length - 1; i++) {
    let subarr = [];
    for (let x in arr[i]) {
      subarr.push(arr[i][x]);
    }
    csvArr.push(subarr);
  }
  return csvArr;
};
export const exportToCsv = (filename: any, rows: any) => {
  var processRow = function (row: any) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null ? '' : row[j]?.toString();
      if (row[j] instanceof Date) {
        innerValue = row[j]?.toLocaleString();
      }
      var result = innerValue?.replace(/"/g, '""');
      if (result?.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
      if (j > 0) finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });

  var link = document.createElement('a');
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    var url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
